export default "__VITE_ASSET__60d8869d__"